(function($) {
  const dynamicNumberHtmlClass = 'order-phone-number';
  const announcementBarNumberClass = 'phone-number-link';

    $(document).ready(function () {
        const keynumberInfo = getKeyNumber();
        addKeyNumberToCartAttributes(keynumberInfo.keynumber);
        setTargetNumber(keynumberInfo);
    });

    function getKeyNumber() {
        let keynumber = (new URLSearchParams(document.location.search.toLowerCase())).get('keynumber') // try url params first as we want to overwrite if there's a new one
                     || (cookiesExist() && Cookies.get('keynumber')); // otherwise try cookies
        let cookieChanged = false;
        if (keynumber && (typeof (keynumber) == 'string')) {
            cookieChanged = setCookie('keynumber', keynumber);
        }
        const keynumberInfo = {
            keynumber: keynumber,
            keynumberChanged: cookieChanged
        };
        return keynumberInfo;
    }

    function addKeyNumberToCartAttributes(keynumber) {
        if (keynumber && (typeof (keynumber) == 'string')) {
            // add keynumber as a cart attribute via post request
            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: { attributes: { KeyNumber: keynumber.toUpperCase() } },
                dataType: 'json'
            });
        }
    }

    function setTargetNumber(keynumberInfo) {
        const cachedNumber = cookiesExist() && Cookies.get('phone');

        if (!!cachedNumber && !keynumberInfo.keynumberChanged) { // if there's a cached target number and our keynumber wasn't overwritten, use the cached targetnumber
            setDynamicNumber(cachedNumber);
        } else if (keynumberInfo.keynumber) { // otherwise use keynumber to fetch target number from api
            //function to handle successful api response
            const handleSuccess = function (data) {
                if (data && data.TargetNumber) { // got a valid api response. use it
                    if (cookiesExist()) { // if we have cookies, cache the targetnumber for the next 30 days
                        setCookie('phone', data.TargetNumber);
                    }
                    setDynamicNumber(data.TargetNumber);
                }
            };
            //fetch associated target number and pass it to success function
            $.ajax({
                type: 'GET',
                url: 'https://branddevelopersproxy.azurewebsites.net/api/keynumber/' + keynumberInfo.keynumber.toUpperCase(),
                success: handleSuccess,
                dataType: 'json'
            });
        }
    }

    // replace cookie if it has changed
    function setCookie(cookieName, cookieValue) {
        if (cookiesExist()) {
            const existingCookie = Cookies.get(cookieName);
            if (existingCookie && (existingCookie.toLowerCase() === cookieValue.toLowerCase())) {
                return false;
            } else {
                Cookies.set(cookieName, cookieValue, { expires: 30 });
                return true;
            }
        }
    }

    function cookiesExist() {
        return typeof (Cookies) == 'function';
    }

    function formatTargetNumber(targetNumber) {
      if(targetNumber && targetNumber.length == 10){
        return targetNumber.slice(0, 4) + " " + targetNumber.slice(4, 7) + " " + targetNumber.slice(7, 10);
      }
      return targetNumber;
    }

    function setDynamicNumber(targetNumber) { 
      const formattedNumber = formatTargetNumber(targetNumber);
      const classSelector = `.${dynamicNumberHtmlClass}`;
      $(classSelector).html(formattedNumber); // set the text content,formatted number
      $(classSelector).attr('href', 'tel:' + targetNumber); // set where the href points to, unformatted

      const announcementBarSelector = `.${announcementBarNumberClass}`;
      $(announcementBarSelector).html('ORDER LINE - ' + formattedNumber);
      $(announcementBarSelector).attr('href', (isMobile() ? ('tel:' + targetNumber) : "https://tvshop.co.nz/pages/call-now"));
    }

    function isMobile() {
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4));
    }
})(window.jQuery);

// Polyfill for IE11 for URLSearchParams to work
(function (w) {
    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        };
    }
})(window);